import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'nl2br' })
export class Nl2brPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, siteId?: number, siteCode?: string, data?: any[]): SafeHtml {
    if (!value) return '';
    let parsed = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // Convert IRN patterns (e.g. H2026/28, H2026/28-1, AB2025/123) to clickable links
    if (siteId !== undefined && siteId !== null) {
      const origin = window.location.origin;
      parsed = parsed.replace(
        /\b([A-Z]{1,3}\d+\/\d+(?:-[A-Z0-9]+)?)\b/gi,
        (match) => {
          let row: any = null;
          if (data && data.length > 0) {
            // 1. Try exact match
            row = data.find(r => (r.IRN || r.irn)?.toUpperCase() === match.toUpperCase());

            // 2. If subtask match (e.g. T2024/82-1) not found, try base IRN (T2024/82)
            if (!row && match.includes('-')) {
              const baseIrn = match.split('-')[0];
              row = data.find(r => (r.IRN || r.irn)?.toUpperCase() === baseIrn.toUpperCase());
            }

            // 3. If parent task match (e.g. T2024/82) not found, check if any subtask starts with T2024/82-
            if (!row && !match.includes('-')) {
              row = data.find(r => (r.IRN || r.irn)?.toUpperCase()?.startsWith(match.toUpperCase() + '-'));
            }
          }

          const taskSiteId = row?.SiteId || row?.siteId || siteId;
          let url = `${origin}/admin/task-manager?SiteId=${taskSiteId}&irn=${encodeURIComponent(match)}`;

          if (row) {
            const taskId = row.TaskId || row.taskId;
            const subTaskId = row.SubTaskId || row.subTaskId;

            if (taskId) {
              if (match.includes('-') && subTaskId && subTaskId > 0) {
                url = `${origin}/subTask?taskId=${taskId}&subTaskId=${subTaskId}&siteId=${taskSiteId}&siteC=${siteCode || ''}`;
              } else {
                url = `${origin}/task?taskId=${taskId}&siteId=${taskSiteId}&siteC=${siteCode || ''}`;
              }
            }
          }

          return `<a href="${url}" target="_blank" class="irn-link" title="Open task ${match}">${match}</a>`;
        }
      );
    }

    // Headings
    parsed = parsed.replace(/^###\s+(.*$)/gim, '<h3>$1</h3>');
    parsed = parsed.replace(/^##\s+(.*$)/gim, '<h2>$1</h2>');
    parsed = parsed.replace(/^#\s+(.*$)/gim, '<h1>$1</h1>');

    // Bold & Italic
    parsed = parsed.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    parsed = parsed.replace(/\*(.*?)\*/g, '<em>$1</em>');

    // Top-level & nested bullet items
    parsed = parsed.replace(/^ {2,}-\s+(.*$)/gim, '<div style="margin-left: 28px; margin-bottom: 3px;">&ndash; $1</div>');
    parsed = parsed.replace(/^-\s+(.*$)/gim, '<div style="margin-left: 14px; margin-bottom: 4px;">&bull; $1</div>');
    parsed = parsed.replace(/^\*\s+(.*$)/gim, '<div style="margin-left: 14px; margin-bottom: 4px;">&bull; $1</div>');
    // Numbered lists
    parsed = parsed.replace(/^(\d+\.)\s+(.*$)/gim, '<div style="margin-left: 14px; margin-bottom: 4px;">$1 $2</div>');
    // Indented numbered sub-items
    parsed = parsed.replace(/^ {2,}(\d+\.\d+\.?)\s+(.*$)/gim, '<div style="margin-left: 28px; margin-bottom: 3px;">$1 $2</div>');

    // Newlines to BR
    parsed = parsed.replace(/\n/g, '<br/>');

    // Clean up excessive breaks after block elements
    parsed = parsed.replace(/(<\/h[1-3]>|<div[^>]*>.*?<\/div>)<br\/>/g, '$1');
    parsed = parsed.replace(/<br\/><br\/>/g, '<br/>');

    return this.sanitizer.bypassSecurityTrustHtml(parsed);
  }
}
